/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
  var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
  if (api && typeof api.t === 'function') return api.t(key, params);
  if (typeof module === 'object' && module.exports && typeof require === 'function') {
    var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
    var dict = require('../json/i18n/' + lang + '/js-runtime.json');
    var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
    return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
  }
  return key;
}

/* Sprawdzarka — HISTORIA TRAFIEN (naprawa 25.09.2026, zgloszenie gracza).
 *
 * Czysty modul bez DOM: uzywa go sprawdz-kupon.html.twig, testuje
 * bin/test-sprawdz-historia.js. Odtwarza dwie funkcje dawnej sprawdzarki
 * (www3 system-check): liste losowan z progiem „co najmniej N trafien”
 * i podsumowanie „dokladnie N trafien” — na obecnych plikach JSON, bez SQL.
 *
 *   klucz(d, kod)               — tozsamosc losowania: gra + draw_system_id,
 *                                 przy braku ID gra + data Z GODZINA (Multi
 *                                 Multi 14:00 i 22:00 tego dnia to dwa losowania)
 *   deduplikuj(lista, kod)      — { lista, duplikaty }; kolejnosc zachowana
 *   policz(losowania, wybrane, wybraneS)
 *                               — [{ d, t, ts }]: trafienia glowne i dodatkowe
 *                                 (Eurojackpot: Euro osobno), niezaleznie od kwot
 *   histogram(wyniki, max, pole) — tablica 0..max: DOKLADNIE N trafien
 *   filtruj(wyniki, filtr)      — filtr { rodzaj: 'wszystkie' | 'min' | 'dokladnie', n }
 *   filtrZTekstu(s, max)        — 'wszystkie' | 'min-3' | 'dok-4' -> filtr albo null
 *   progi(max)                  — dopuszczalne progi „co najmniej” 1..max
 *   pobierzRoczniki(o)          — { draws, pobrane, brakujace } — blad pobrania
 *                                 rocznika NIE jest pustym rokiem i NIE trafia
 *                                 do cache
 *   zakresDat(lista)            — { od, do } z faktycznych dat losowan
 *   wystapienia(losowania, wskazane)
 *                               — Fala 4.3C (25.09.2026): losowania, ktore
 *                                 zawieraja WSZYSTKIE wskazane liczby (3, 4 albo 5;
 *                                 tylko liczby glowne). Jedno losowanie liczy sie
 *                                 raz, niezaleznie od liczby podzbiorow. Bez kwot.
 *   wskazanePoprawne(wskazane)  — dokladnie 3..5 roznych liczb calkowitych > 0
 *   ostatnie(o)                 — Fala 6C (26.09.2026): N ostatnich losowan z recent.json
 *                                 i rocznikow; brak/niepelny plik = odrzucenie, nie zero
 */
(function (root) {
    'use strict';

    function idLosowania(d) {
        var v = d ? (d.draw_system_id != null ? d.draw_system_id : d.legacy_id) : null;
        if (typeof v === 'number' && isFinite(v) && v > 0 && v % 1 === 0) { return String(v); }
        if (typeof v === 'string' && /^[1-9][0-9]{0,11}$/.test(v.trim())) { return v.trim(); }
        return null;
    }

    function klucz(d, kod) {
        var id = idLosowania(d);
        if (id) { return kod + '#' + id; }
        var t = d && typeof d.drawn_at === 'string' ? d.drawn_at.trim() : '';
        return t ? kod + '@' + t : null;
    }

    function deduplikuj(lista, kod) {
        var bylo = {}, byloLosowanie = {}, out = [], duplikaty = 0;
        (Array.isArray(lista) ? lista : []).forEach(function (d) {
            var k = klucz(d, kod);
            // Recent i rocznik moga opisac to samo losowanie z roznymi ID
            // (np. Mini Lotto: numer w recent, null w roczniku).
            var sygnatura = d && typeof d.drawn_at === 'string' && Array.isArray(d.numbers) && Array.isArray(d.special)
                ? kod + '@' + d.drawn_at + ':' + d.numbers.slice().sort(function (a, b) { return a - b; }).join(',')
                    + '+' + d.special.slice().sort(function (a, b) { return a - b; }).join(',') : null;
            if (sygnatura && byloLosowanie[sygnatura]) { duplikaty++; return; }
            if (k === null) { out.push(d); return; }       // bez ID i daty: nie zgadujemy
            if (bylo[k]) { duplikaty++; return; }
            bylo[k] = true;
            if (sygnatura) { byloLosowanie[sygnatura] = true; }
            out.push(d);
        });
        return { lista: out, duplikaty: duplikaty };
    }

    function policz(losowania, wybrane, wybraneS) {
        var W = {}, WS = {};
        (wybrane || []).forEach(function (n) { W[n] = true; });
        (wybraneS || []).forEach(function (n) { WS[n] = true; });
        return (losowania || []).map(function (d) {
            var t = 0, ts = 0;
            (d.numbers || []).forEach(function (n) { if (W[n]) { t++; } });
            (d.special || []).forEach(function (n) { if (WS[n]) { ts++; } });
            return { d: d, t: t, ts: ts };
        });
    }

    function histogram(wyniki, max, pole) {
        pole = pole || 't';
        var h = [];
        for (var i = 0; i <= max; i++) { h.push(0); }
        (wyniki || []).forEach(function (w) {
            var v = w[pole];
            if (v >= 0 && v <= max) { h[v]++; }
        });
        return h;
    }

    function filtruj(wyniki, filtr) {
        if (!filtr || filtr.rodzaj === 'wszystkie') { return (wyniki || []).slice(); }
        return (wyniki || []).filter(function (w) {
            return filtr.rodzaj === 'min' ? w.t >= filtr.n : w.t === filtr.n;
        });
    }

    function filtrZTekstu(s, max) {
        if (s === 'wszystkie') { return { rodzaj: 'wszystkie', n: 0 }; }
        var m = /^(min|dok)-(\d{1,2})$/.exec(String(s || ''));
        if (!m) { return null; }
        var n = parseInt(m[2], 10);
        if (m[1] === 'min') { return n >= 1 && n <= max ? { rodzaj: 'min', n: n } : null; }
        return n >= 0 && n <= max ? { rodzaj: 'dokladnie', n: n } : null;
    }

    function progi(max) {
        var out = [];
        for (var i = 1; i <= max; i++) { out.push(i); }
        return out;
    }

    function zakresDat(lista) {
        var od = null, doD = null;
        (lista || []).forEach(function (d) {
            var t = typeof d.drawn_at === 'string' ? d.drawn_at : '';
            if (!t) { return; }
            if (od === null || t < od) { od = t; }
            if (doD === null || t > doD) { doD = t; }
        });
        return { od: od, do: doD };
    }

    /* WYSTAPIENIA WSKAZANYCH LICZB (Fala 4.3C). Niepelny zestaw (3-5 liczb) NIE
       jest kuponem: nie ma tu stopni, wyplat ani „co najmniej". Losowanie
       zalicza sie, gdy KAZDA wskazana liczba jest wsrod jego liczb glownych —
       [1,2,3] w [1,2,3,4,5,6] to jedno losowanie, nie C(6,3) kombinacji. */
    var WSK_MIN = 3, WSK_MAX = 5;
    function wskazanePoprawne(wskazane) {
        if (!Array.isArray(wskazane) || wskazane.length < WSK_MIN || wskazane.length > WSK_MAX) { return false; }
        var bylo = {};
        for (var i = 0; i < wskazane.length; i++) {
            var n = wskazane[i];
            if (typeof n !== 'number' || !isFinite(n) || n % 1 !== 0 || n < 1 || bylo[n]) { return false; }
            bylo[n] = true;
        }
        return true;
    }
    function wystapienia(losowania, wskazane) {
        if (!wskazanePoprawne(wskazane)) { return null; }
        return (losowania || []).filter(function (d) {
            var liczby = d && Array.isArray(d.numbers) ? d.numbers : [];
            for (var i = 0; i < wskazane.length; i++) {
                if (liczby.indexOf(wskazane[i]) === -1) { return false; }
            }
            return true;
        });
    }

    /* Kwota z jackpot.json jest aktualna tylko dla terminu, z ktorym przyszla.
       Po rozpoczeciu losowania stary plik moze lezec do nastepnego crona.
       Nie laczymy wtedy minionego terminu z komunikatem „dzis kumulacja”. */
    function kwotaAktualna(j, teraz) {
        if (!j || typeof j !== 'object') { return 0; }
        var kwota = Number(j.amount);
        if (!isFinite(kwota) || kwota <= 0) { return 0; }
        var termin = j.kwota_dla || j.next_draw;
        if (typeof termin !== 'string' || !termin.trim()) { return 0; }
        var terminMs = Date.parse(termin);
        var terazMs = teraz == null ? Date.now() : (teraz instanceof Date ? teraz.getTime() : Number(teraz));
        if (!isFinite(terminMs) || !isFinite(terazMs) || terminMs < terazMs) { return 0; }
        return kwota;
    }

    /* o = { lata: [..], adres: function (rok) -> url, cache: {}, pobierz: fetch }
       Rocznik jest POBRANY tylko przy HTTP 2xx i poprawnym JSON z tablica
       `draws`. Kazdy inny wynik (404, 5xx, siec, zly JSON) = brakujacy rok:
       nie trafia do cache i jest zwracany w `brakujace`, zeby strona mogla
       powiedziec, czego brakuje, i dac ponowienie. Do 25.09.2026 blad dawal
       tu pusta liste i wynik „cala historia” bez slowa o dziurze. */
    function pobierzRoczniki(o) {
        var cache = o.cache || {};
        var pobierz = o.pobierz || (typeof root.fetch === 'function' ? root.fetch.bind(root) : null);
        var lata = (o.lata || []).slice();
        return Promise.all(lata.map(function (r) {
            if (Object.prototype.hasOwnProperty.call(cache, r)) { return Promise.resolve({ rok: r, ok: true, draws: cache[r] }); }
            if (!pobierz) { return Promise.resolve({ rok: r, ok: false }); }
            return Promise.resolve()
                .then(function () { return pobierz(o.adres(r)); })
                .then(function (odp) {
                    if (!odp || !odp.ok) { return { rok: r, ok: false }; }
                    return odp.json().then(function (d) {
                        if (!d || !Array.isArray(d.draws)) { return { rok: r, ok: false }; }
                        cache[r] = d.draws;
                        return { rok: r, ok: true, draws: d.draws };
                    });
                })
                .catch(function () { return { rok: r, ok: false }; });
        })).then(function (paczki) {
            var draws = [], pobrane = [], brakujace = [];
            paczki.forEach(function (p) {
                if (p.ok) { pobrane.push(p.rok); draws = draws.concat(p.draws); }
                else { brakujace.push(p.rok); }
            });
            draws.sort(function (a, b) { return (b.drawn_at || '').localeCompare(a.drawn_at || ''); });
            return { draws: draws, pobrane: pobrane, brakujace: brakujace.sort(function (a, b) { return a - b; }) };
        });
    }

    // Pobieramy roczniki kolejno: nie znamy z gory liczby losowan w kazdym roku.
    async function pobierzOstatnie(o) {
        if (!Number.isInteger(o.n) || o.n < 1 || o.n > 500) { throw new Error('zakres'); }
        var p = { draws: deduplikuj(o.recent || [], o.kod).lista, pobrane: [], brakujace: [] };
        var lata = (o.lata || []).slice().sort(function (a, b) { return b - a; });
        function aktualne() { if (o.active && !o.active()) { var e = new Error('cancelled'); e.name = 'AbortError'; throw e; } }
        for (var i = 0; i < lata.length && p.draws.length < o.n; i++) {
            aktualne();
            var rok = await pobierzRoczniki({ lata: [lata[i]], cache: o.cache, pobierz: o.pobierz,
                adres: function (r) { return '/assets/json/db/' + o.kod + '/rok-' + r + '.json'; } });
            aktualne();
            p.pobrane = p.pobrane.concat(rok.pobrane); p.brakujace = p.brakujace.concat(rok.brakujace);
            // Starsze wyniki nie moga zastapic nieznanego fragmentu ostatnich N.
            if (rok.brakujace.length) { break; }
            p.draws = deduplikuj(p.draws.concat(rok.draws), o.kod).lista;
        }
        p.draws = p.draws.sort(odNajnowszego).slice(0, o.n);
        return p;
    }

    // Cala dostepna historia: lata z metadanych (bez sztucznych luk),
    // ograniczona liczba rownoleglych pobran i jawny raport brakujacych plikow.
    async function pobierzWszystkie(o) {
        var lata = (o.lata || []).filter(function (r) { return Number.isInteger(r); })
            .slice().sort(function (a, b) { return b - a; });
        var baza = '/assets/json/db/' + o.kod + '/';
        var wynik = { draws: deduplikuj(o.recent || [], o.kod).lista, pobrane: [], brakujace: [] };
        var indeks = 0, rownolegle = Math.max(1, Math.min(4, Number(o.rownolegle) || 4));
        function aktualne() {
            if (o.active && !o.active()) { var e = new Error('cancelled'); e.name = 'AbortError'; throw e; }
        }
        async function pracownik() {
            while (true) {
                aktualne();
                var i = indeks++;
                if (i >= lata.length) { return; }
                var rok = lata[i];
                var paczka = await pobierzRoczniki({ lata: [rok], cache: o.cache, pobierz: o.pobierz,
                    adres: function (r) { return baza + 'rok-' + r + '.json'; } });
                aktualne();
                wynik.pobrane = wynik.pobrane.concat(paczka.pobrane);
                wynik.brakujace = wynik.brakujace.concat(paczka.brakujace);
                wynik.draws = deduplikuj(wynik.draws.concat(paczka.draws), o.kod).lista;
                if (typeof o.onProgress === 'function') { o.onProgress(wynik.pobrane.length + wynik.brakujace.length, lata.length, rok); }
            }
        }
        await Promise.all(Array.from({ length: Math.min(rownolegle, Math.max(1, lata.length)) }, pracownik));
        aktualne();
        wynik.draws.sort(odNajnowszego);
        wynik.pobrane.sort(function (a, b) { return a - b; });
        wynik.brakujace.sort(function (a, b) { return a - b; });
        return wynik;
    }

    /* OSTATNIE N LOSOWAN (Fala 6C, 26.09.2026) — wspolny loader dla historii
       zestawu w centrum „Moje kupony”. Te same lokalne pliki co sprawdzarka:
       recent.json (do 50), potem roczniki rok-RRRR.json wg listy `lata` z heatmap.json
       (jak analizator; bez niej — od biezacego roku w dol), az bedzie N. Zero zapytan do zewnetrznego API. Blad pliku albo za malo
       losowan = ODRZUCENIE (stan bledu z ponowieniem), nigdy pusty wynik.
       o = { kod, n, pobierz (fetch), rok (biezacy), cache, maxLat }
       -> Promise<{ draws (od najnowszego, bez duplikatow, dokladnie n), zakres }> */
    function odNajnowszego(a, b) { return (Date.parse(b.drawn_at) || 0) - (Date.parse(a.drawn_at) || 0); }
    function ostatnie(o) {
        var kod = o.kod, n = o.n, pobierz = o.pobierz || (typeof root.fetch === 'function' ? root.fetch.bind(root) : null);
        var baza = '/assets/json/db/' + kod + '/';
        if (!pobierz) { return Promise.reject(new Error('brak-fetch')); }
        function gotowe(lista) { var l = deduplikuj(lista.slice().sort(odNajnowszego), kod).lista.slice(0, n); return { draws: l, zakres: zakresDat(l) }; }
        return Promise.resolve()
            .then(function () { return pobierz(baza + 'recent.json'); })
            .then(function (r) { if (!r || !r.ok) { throw new Error('recent'); } return r.json(); })
            .then(function (d) {
                if (!d || !Array.isArray(d.draws)) { throw new Error('recent-format'); }
                var zbior = d.draws.slice();
                if (deduplikuj(zbior, kod).lista.length >= n) { return gotowe(zbior); }
                var maxLat = o.maxLat || 6, lata = null, zHeatmapy = false, proby = 0;
                // Lista rocznikow jak w analizatorze: heatmap.json `lata` (plik serwisu);
                // gdy go brak — od biezacego roku w dol. Brak WYMIENIONEGO rocznika = blad.
                function listaLat() {
                    if (lata) { return Promise.resolve(lata); }
                    return Promise.resolve().then(function () { return pobierz(baza + 'heatmap.json'); })
                        .then(function (r) { return r && r.ok ? r.json() : null; })
                        .catch(function () { return null; })
                        .then(function (h) {
                            var z = h && h.lata && typeof h.lata === 'object' ? Object.keys(h.lata).filter(function (y) { return /^\d{4}$/.test(y); }).map(Number).sort(function (a, b) { return b - a; }) : [];
                            if (z.length) { zHeatmapy = z.length <= maxLat; } else { var r0 = o.rok || new Date().getFullYear(); for (var i = 0; i < maxLat; i++) { z.push(r0 - i); } }
                            lata = z.slice(0, maxLat);
                            return lata;
                        });
                }
                function dalej() {
                    return listaLat().then(function (l) {
                        // Cala wymieniona historia pobrana poprawnie, a losowan mniej niz n: pokazujemy tyle, ile jest (licznik i daty mowia prawde).
                        if (proby >= l.length) { if (zHeatmapy && zbior.length) { return gotowe(zbior); } throw new Error('za-malo'); }
                        var rok = l[proby++];
                        return pobierzRoczniki({ lata: [rok], cache: o.cache, pobierz: pobierz, adres: function (r) { return baza + 'rok-' + r + '.json'; } })
                            .then(function (p) {
                                if (p.brakujace.length) { throw new Error('rocznik-' + rok); }
                                zbior = zbior.concat(p.draws);
                                if (deduplikuj(zbior, kod).lista.length >= n) { return gotowe(zbior); }
                                return dalej();
                            });
                    });
                }
                return dalej();
            });
    }

    // Preserve known recent payouts and merge partial historical degrees by stable ID.
    function scalWygrane(draws, sources, kod) {
        var known = Object.create(null);
        (sources || []).forEach(function (d) { var k = klucz(d, kod); if (!k) { return; }
            if (!known[k]) { known[k] = Object.create(null); }
            (d.prizes || []).forEach(function (p) {
                if (!Number.isInteger(p.degree) || p.degree < 1) { return; }
                var old = known[k][p.degree];
                if (!old || (p.amount != null && Number.isFinite(p.amount) && p.amount > 0)) { known[k][p.degree] = p; }
            });
        });
        return (draws || []).map(function (d) { var k = klucz(d, kod), prizes = known[k];
            if (!prizes) { return d; }
            (d.prizes || []).forEach(function (p) { if (!prizes[p.degree] || (p.amount != null && Number.isFinite(p.amount) && p.amount > 0)) { prizes[p.degree] = p; } });
            return Object.assign({}, d, { prizes: Object.keys(prizes).map(function (n) { return prizes[n]; }) });
        });
    }

    function pobierzWygrane(o) {
        var merged = scalWygrane(o.draws, o.recent, o.kod);
        if (['multi-multi', 'kaskada'].indexOf(o.kod) !== -1) { return Promise.resolve({ draws: merged, brakujace: [] }); }
        var years = [...new Set(merged.filter(function (d) { return o.complete || !d.prizes || !d.prizes.length; })
            .map(function (d) { return parseInt((d.drawn_at || '').slice(0, 4), 10); }).filter(Number.isInteger))];
        return Promise.all(years.map(function (year) {
            var k = o.kod + ':' + year;
            if (o.cache[k]) { return Promise.resolve({ draws: o.cache[k], year: year }); }
            return (o.pobierz || fetch)('/assets/json/db/' + o.kod + '/wygrane-' + year + '.json')
                .then(function (r) { if (!r.ok) { throw Error('prizes'); } return r.json(); })
                .then(function (p) { if (p.code !== o.kod || p.year !== year || !Array.isArray(p.draws)) { throw Error(jst("ui.9967049c31e00ef5")); }
                    o.cache[k] = p.draws; return { draws: p.draws, year: year }; })
                .catch(function () { return { draws: [], year: year, missing: true }; });
        })).then(function (all) { return { draws: scalWygrane(merged, all.flatMap(function (p) { return p.draws; }), o.kod),
            brakujace: all.filter(function (p) { return p.missing; }).map(function (p) { return p.year; }) }; });
    }


    // Jedna definicja stopni dla sprawdzarki i porównania zapisanych zestawów.
  function kodMM(skreslen, trafien, plus) {
    var progi = [1, 2, 2, 2, 3, 3, 3, 4, 4, 4];
    if (skreslen < 1 || skreslen > 10 || trafien < 0 || trafien > skreslen) { return 0; }
    if (!plus) {
      if (trafien === 0) { return 0; }       // tabela podstawowa nie placi za zero
      var kod = 1;
      for (var n = 1; n <= 10; n++) {
        for (var t = progi[n - 1]; t <= n; t++) {
          if (n === skreslen && t === trafien) { return kod; }
          kod++;
        }
      }
      return 0;
    }
    if (trafien === 0) { return 0; }          // Trafiony Plus jest jedna z trafionych liczb
    var start = 45;
    for (var m = 1; m < skreslen; m++) { start += m; }   // grupa ma `m` slotow
    return start + (trafien - 1);
  }

  var STOPIEN = {
    'lotto':       function (t) { return t >= 3 ? 7 - t : 0; },        // 6->1, 5->2, 4->3, 3->4
    'lotto-plus':  function (t) { return t >= 3 ? 7 - t : 0; },
    'mini-lotto':  function (t) { return t >= 3 ? 6 - t : 0; },        // 5->1, 4->2, 3->3
    'eurojackpot': function (t, s) {
      var k = t + '+' + s;
      var m = {'5+2':1,'5+1':2,'5+0':3,'4+2':4,'4+1':5,'3+2':6,'4+0':7,'2+2':8,'3+1':9,'3+0':10,'1+2':11,'2+1':12};
      return m[k] || 0;
    },
    // Kaskada: stale kwoty za 12..8 trafien (250 000 / 1 000 / 25 / 8 / 2 zl),
    // czyli piec stopni — zgodne z podzialem wygranych w danych API.
    'kaskada':     function (t) { return t >= 8 ? 13 - t : 0; },       // 12->1 ... 8->5
    'multi-multi': function (t, s, skreslen) { return kodMM(skreslen, t, false); }
  };

    function bilans(kod, wyniki, liczby, cena, stawki) {
        var suma = 0, brak = 0, rows = [];
        wyniki.forEach(function (w) {
            var degree = STOPIEN[kod] ? STOPIEN[kod](w.t, w.ts, liczby) : null;
            var amount = degree === 0 ? 0 : null;
            if (degree > 0) {
                var prize = (w.d.prizes || []).find(function (p) {
                    return +p.degree === degree && typeof p.amount === 'number' && Number.isFinite(p.amount) && p.amount > 0 && (!p.currency || p.currency.toUpperCase() === 'PLN');
                });
                if (prize) amount = prize.amount;
                if (amount === null && ['multi-multi','kaskada'].indexOf(kod) >= 0) {
                    var day = (w.d.drawn_at || '').slice(0,10);
                    var period = ((stawki || {})[degree] || []).find(function (r) { return day >= r[0] && day <= r[1] && typeof r[2] === 'number' && r[2] > 0; });
                    if (period) amount = period[2];
                }
            }
            if (amount === null) brak++; else suma += Math.round(amount * 100);
            rows.push({date:w.d.drawn_at, hits:w.t, extra:w.ts, degree:degree, amount:amount});
        });
        var koszt = cena===null ? null : Math.round(cena * 100) * wyniki.length;
        return {suma:suma/100, brak:brak, koszt:koszt===null?null:koszt/100, saldo:brak || koszt===null ? null : (suma-koszt)/100, rows:rows};
    }
    // Próg dotyczy liczb głównych. Dane wejściowe: od najnowszego losowania.
    function serie(wyniki, prog) {
        var run=0, gap=0, maxRun=0, maxGap=0, current=0, successes=0;
        wyniki.forEach(function (w, i) {
            if(w.t >= prog){run++;gap=0;successes++;maxRun=Math.max(maxRun,run);}
            else {gap++;run=0;maxGap=Math.max(maxGap,gap);if(i===current)current++;}
        });
        return {sukcesy:successes, seria:maxRun, przerwa:maxGap, biezaca:current};
    }
    var api = {
        stopnie: STOPIEN, kodMM: kodMM, bilans: bilans, serie: serie,
        scalWygrane: scalWygrane, pobierzWygrane: pobierzWygrane,
        ostatnie: ostatnie, pobierzOstatnie: pobierzOstatnie, pobierzWszystkie: pobierzWszystkie,
        klucz: klucz, deduplikuj: deduplikuj, policz: policz, histogram: histogram,
        filtruj: filtruj, filtrZTekstu: filtrZTekstu, progi: progi, zakresDat: zakresDat,
        pobierzRoczniki: pobierzRoczniki, kwotaAktualna: kwotaAktualna, NA_STRONE: 50,
        wystapienia: wystapienia, wskazanePoprawne: wskazanePoprawne, WSK_MIN: WSK_MIN, WSK_MAX: WSK_MAX
    };
    if (typeof module === 'object' && module && module.exports) { module.exports = api; }
    root.PewniakiHistoria = api;
})(typeof globalThis !== 'undefined' ? globalThis : this);
